<template>
  <div>
    <Header />
    <Servicios />
    <Separator />
    <Certificaciones />
    <Nosotros />
    <Contacto />
    <Footer />
  </div>
</template>

<script>
import Header from './Header'
import Nosotros from './Nosotros'
import Separator from './Separator'
import Certificaciones from './Certificaciones'
import Contacto from './Contacto'
import Footer from './Footer'
import Servicios from './Servicios'

export default {
  name: 'Home',
  components: {
    Header,
    Nosotros,
    Separator,
    Certificaciones,
    Contacto,
    Footer,
    Servicios
  }
}
</script>
